export default __webpack_public_path__ + "static/media/Srijan Capital Advisors LLP Logo.5b35b40b.png";